import { RefObject, useEffect } from "react"

export const useClickOutside = ({ ref, callBack }: { ref: RefObject<HTMLElement>; callBack: () => void }) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callBack?.()
      }
    }

    document.addEventListener("mouseup", handleClickOutside)
    return () => {
      document.removeEventListener("mouseup", handleClickOutside)
    }
  }, [callBack, ref])
}
